import { CobaltLoaderCircular } from '@cae/cobalt-react/components/loader-circular';
import * as React from 'react';

import type { ContentLoaderProps } from './ContentLoader.types';

import styles from './ContentLoader.module.css';

const ContentLoader = React.memo(
  ({ label }: Readonly<ContentLoaderProps>): React.ReactElement => {
    return (
      <div className={styles.contentLoader} data-testid="content-loader">
        <div className={styles.contentLoaderBackground} />
        <div className={styles.contentLoaderContent}>
          <CobaltLoaderCircular size="large" />
          {label && <p className="body-02">{label}</p>}
        </div>
      </div>
    );
  }
);

ContentLoader.displayName = 'ContentLoader';

export { ContentLoader };
